module.exports = __webpack_public_path__ + "static/media/1.50e440f3.gif";